import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Sidenav from '../components/Sidenav';
import HomePage from '../pages/HomePage';
import LoginPage from '../pages/LoginPage';
import RegisterPage from '../pages/RegisterPage';
import UserProfilePage from '../pages/UserProfilePage';
import RegistrationSuccessPage from '../pages/RegistrationSuccessPage';
import TerminalesPage from '../pages/TerminalesPage';
import GraphPage from '../pages/GraphPage';
import MapaPage from '../pages/MapaPage';
import DashboardPage from '../pages/DashboardPage';
import ClientsPage from '../pages/admin/ClientsPage';
import TerminalsAdminPage from '../pages/admin/TerminalsAdminPage';
import UsersAdminPage from '../pages/admin/UsersAdminPage';
import ContractsAdminPage from '../pages/admin/ContractsAdminPage';
import GraphsOverviewPage from '../pages/GraphsOverviewPage';

const ProtectedRoute = ({ token, children }) => {
  return token ? children : <Navigate to="/login" />;
};

const AdminRoute = ({ token, user, children }) => {
  if (!token) return <Navigate to="/login" />;
  if (!user || user.role !== 1) return <Navigate to="/" />;
  return children;
};

const ClientRoute = ({ token, user, children }) => {
  if (!token) return <Navigate to="/login" />;
  if (!user || user.role === 1) return <Navigate to="/admin/clientes" />;
  return children;
};

const PublicOnlyRoute = ({ token, children }) => {
  if (!token) return children;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.role === 1 ? <Navigate to="/admin/clientes" /> : <Navigate to="/dashboard" />;
  } catch {
    return <Navigate to="/dashboard" />;
  }
};

const AppRouter = ({ token, user, handleLoginSuccess, handleRegisterSuccess, handleLogout }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        {token && <Sidenav user={user} open={sidebarOpen} onClose={() => setSidebarOpen(false)} />}
        <div className={`${token ? 'md:ml-64' : ''}`}>
          <Navbar token={token} user={user} onLogout={handleLogout} onToggleSidebar={() => setSidebarOpen(!sidebarOpen)} />
          <main className={`${token ? 'pt-16 pb-16 px-4 md:px-6' : 'min-h-screen'}`}>
            <Routes>
              <Route path="/" element={<PublicOnlyRoute token={token}><HomePage /></PublicOnlyRoute>} />
              <Route path="/login" element={<PublicOnlyRoute token={token}><LoginPage onLoginSuccess={handleLoginSuccess} /></PublicOnlyRoute>} />
              <Route path="/register" element={<PublicOnlyRoute token={token}><RegisterPage onRegisterSuccess={handleRegisterSuccess} /></PublicOnlyRoute>} />
              <Route path="/registration-success" element={<RegistrationSuccessPage />} />
              <Route path="/profile" element={<ProtectedRoute token={token}><UserProfilePage token={token} handleLogout={handleLogout} /></ProtectedRoute>} />
              <Route path="/dashboard" element={<ClientRoute token={token} user={user}><DashboardPage token={token} user={user} /></ClientRoute>} />
              <Route path="/terminales" element={<ClientRoute token={token} user={user}><TerminalesPage token={token} user={user} /></ClientRoute>} />
              <Route path="/graficos" element={<ClientRoute token={token} user={user}><GraphsOverviewPage token={token} /></ClientRoute>} />
              <Route path="/graficos/:guid" element={<ClientRoute token={token} user={user}><GraphPage token={token} /></ClientRoute>} />
              <Route path="/mapa" element={<ClientRoute token={token} user={user}><MapaPage token={token} /></ClientRoute>} />
              <Route path="/admin/clientes" element={<AdminRoute token={token} user={user}><ClientsPage token={token} /></AdminRoute>} />
              <Route path="/admin/terminales" element={<AdminRoute token={token} user={user}><TerminalsAdminPage token={token} /></AdminRoute>} />
              <Route path="/admin/usuarios" element={<AdminRoute token={token} user={user}><UsersAdminPage token={token} /></AdminRoute>} />
              <Route path="/admin/contratos" element={<AdminRoute token={token} user={user}><ContractsAdminPage token={token} /></AdminRoute>} />
            </Routes>
          </main>
        </div>
      </div>
    </Router>
  );
};

export default AppRouter;
